<template>
  <div class="flex flex-row flex-wrap gap-2 max-w-full">
    <DynamicLink
      v-for="(button, i) in buttons"
      :label="button.label"
      :link="button.link"
      :class="['button', { ['button-secondary']: i > 0 }]"
    />
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { DynamicLink } from "@/components/small";

export default {
  name: "OptionalButtons",
  components: { DynamicLink },
  props: {
    buttons: {
      type: Array as PropType<Link[]>,
      default: null,
    },
  },
};
</script>
